<template>
  <div class="about">
    <Header :index="'about'" style="position:fixed;top:0;" />
    <div class="content">
      <div class="top">
        <p class="title">关于大会</p>
      </div>
      <div class="main" v-html="aboutUs"></div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import {
  pushLog,
  logProdType,
  targetType,
  eventType,
  pageType
} from '../global/config'
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      eid: this.$route.query.eid || '', //会议id

      aboutUs: ''
    }
  },
  methods: {
    search() {
    this.$callApi(this.$apiList.HOME_GET_INFO, { eid: this.eid })
      .then(res => {
        this.eid = res.data.eid;
        this.aboutUs = res.data.aboutUs
      })
    },
    beforeunloadFn(e) {
      pushLog(
        this,
        logProdType.PC,
        pageType.ABOUT,
        eventType.PAGE_CLOSE,
        targetType.PAGE,
        '/about'
      )
    },
    beforeloadFn(e) {
      pushLog(
        this,
        logProdType.PC,
        pageType.ABOUT,
        eventType.PAGE_LOAD,
        targetType.PAGE,
        '/about'
      )
    }
  },
  created() {
    this.search()
    window.addEventListener('beforeunload', e => this.beforeloadFn(e))
  },
  mounted() {
    window.scrollTo(0, 0)
    this.$ba.trackPageview('/about')
    this.beforeloadFn()
  },
  destroyed() {
    window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
  }
};
</script>
<style scoped lang="less">
  .about {
    background-size: cover;
    background-image: url('https://cdn.huodongxing.com/web-meeting/js/img/pc/background.png');

    .content {
      width: 1080px;
      min-height: 820px;
      padding-top: 80px;
      margin: 0 auto 60px;
      color: rgba(255, 255, 255, 0.8);

      .top {
        .title {
          margin: 20px 0 30px;
          font-size: 32px;
          line-height: 45px;
          font-weight: 500;
          color: #ffffff;
          text-indent: 36px;
          background-image: url('../assets/imgs/web-meeting/title.png');
          background-repeat: no-repeat;
          background-size: 26px 39px;
          background-position: 0 center;
        }
      }

      .main {
        box-sizing: border-box;
        width: 1080px;
        padding: 20px;
        background: rgba(255, 255, 255, 0.15);
        border-radius: 6px;
      }
    }
  }
</style>
